import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router'
import GridSpinner from 'components/UI/GridSpinner'
import { areRouteModulesReady, ensureRouteModulesLoaded } from 'store/domains/utils'
import { ensureI18nNamespacesLoaded } from 'i18nProduct'

const RouteModuleRenderer = ({ routeKey, routePath, RouteComponent, shellI18nNamespaces = [] }) => {
  const { pathname } = useLocation()
  const [isReady, setIsReady] = useState(() => areRouteModulesReady(pathname, routeKey))

  // Gate first paint on route identity — not on :param changes (e.g. /wallets/1 → /wallets/2).
  useEffect(() => {
    let mounted = true

    const run = async () => {
      if (!areRouteModulesReady(pathname, routeKey)) {
        setIsReady(false)
      }

      await ensureRouteModulesLoaded(pathname, routeKey)

      if (mounted) {
        setIsReady(true)
      }
    }

    run()

    return () => {
      mounted = false
    }
  }, [routeKey])

  useEffect(() => {
    ensureI18nNamespacesLoaded({
      routeKey,
      routePath,
      pathname,
      extraNamespaces: shellI18nNamespaces,
    }).catch(() => {})
  }, [routeKey, routePath, pathname, shellI18nNamespaces])

  if (!isReady) {
    return <GridSpinner />
  }

  if (!RouteComponent) {
    return null
  }

  return <RouteComponent />
}

RouteModuleRenderer.propTypes = {
  routeKey: PropTypes.string,
  routePath: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  RouteComponent: PropTypes.any,
  shellI18nNamespaces: PropTypes.arrayOf(PropTypes.string),
}

export default RouteModuleRenderer
